import { useReimbursementRequestContext } from "../../../Contexts/ReimbursementRequestContext";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { truncateStr } from "../../../utilities/helper";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

function UploadOPMedRx() {
  const {
    setShowUploadModal,
    setUploadField,
    setErrorField,
    setFormData,
    errorField,
    formData,
  } = useReimbursementRequestContext();

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (file) {
      if (file.size > 1000000) {
        setErrorField("opMedicinePrescription");
      } else {
        setErrorField("");
      }
      let newForm = {
        ...formData,
        opMedicinePrescription: file,
      };
      setFormData(newForm);
    }
  };

  const handleUpload = () => {
    setShowUploadModal(true);
    setUploadField("opMedicinePrescription");
  };

  let uploadBtn = null;

  if (/Mobi/.test(navigator.userAgent)) {
    uploadBtn = (
      <div>
        <label
          htmlFor="opMedicinePrescription"
          className="hover:underline text-sm flex items-center text-[#0947AB]"
        >
          <AttachFileIcon fontSize="22" sx={{ transform: "rotate(45deg)" }} />
          Attach file
        </label>

        <input
          type="file"
          className="hidden"
          id="opMedicinePrescription"
          name="opMedicinePrescription"
          accept=".png, .jpg, .jpeg, .pdf"
          onChange={handleFileChange}
        />
      </div>
    );

    if (formData.opMedicinePrescription) {
      uploadBtn = (
        <div>
          <label
            htmlFor="opMedicinePrescription"
            className="text-sm flex items-center text-[#0947AB]"
          >
            <p className="text-sm text-[#60656D] mr-2">
              {truncateStr(formData.opMedicinePrescription?.name)}
            </p>
            <span className="hover:underline">Reupload</span>
          </label>

          <input
            type="file"
            className="hidden"
            id="opMedicinePrescription"
            name="opMedicinePrescription"
            accept=".png, .jpg, .jpeg, .pdf"
            onChange={handleFileChange}
          />
        </div>
      );
    }
  } else {
    uploadBtn = (
      <button
        onClick={handleUpload}
        className="hover:underline text-sm flex items-center text-[#0947AB]"
      >
        <AttachFileIcon fontSize="22" sx={{ transform: "rotate(45deg)" }} />
        Attach file
      </button>
    );

    if (formData.opMedicinePrescription) {
      uploadBtn = (
        <button
          onClick={handleUpload}
          className="text-sm flex items-center text-[#0947AB]"
        >
          <p className="text-sm text-[#60656D] mr-2">
            {truncateStr(formData.opMedicinePrescription?.name)}
          </p>
          <span className="hover:underline">Reupload</span>
        </button>
      );
    }
  }

  let successIcon = null;

  if (formData.opMedicinePrescription) {
    if (errorField === "opMedicinePrescription") {
      successIcon = (
        <div className="rounded-full bg-[#fae6e6] w-[25px] h-[25px] flex items-center justify-center">
          <CloseIcon sx={{ color: "#b70000" }} fontSize="18" />
        </div>
      );
    } else {
      successIcon = (
        <div className="rounded-full bg-[#e6efea] w-[25px] h-[25px] flex items-center justify-center">
          <CheckIcon sx={{ color: "#085f28" }} fontSize="18" />
        </div>
      );
    }
  }

  const fileErrorMsg = errorField === "opMedicinePrescription" && (
    <p className="text-sm text-red-600 mt-2 ml-2">
      File size exceeds limit. Upload smaller file
    </p>
  );

  return (
    <div className="mb-4">
      <p className="mb-2 text-[#60656D]">
        Prescription for medicine purchased (with date, name of patient, prescribing doctor, license number, TIN and details of medicine - name, dosage, quantity)
      </p>
      <div
        className={`flex items-center justify-between border rounded-lg p-3 ${
          errorField === "opMedicinePrescription" ? "border-red-600" : ""
        }`}
      >
        <div>
          <p className="font-semibold mb-2">
            Prescription for medicines purchased
          </p>
          <div>{uploadBtn}</div>
        </div>
        {successIcon}
      </div>
      {fileErrorMsg}
    </div>
  );
}

export default UploadOPMedRx;